import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/providers/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@afa-shared/afa-components/dist/index.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../fonts/Ambit-Regular.woff2\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"../fonts/Ambit-Regular.woff\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"../fonts/Ambit-Bold.woff2\",\"weight\":\"700\",\"style\":\"normal\"},{\"path\":\"../fonts/Ambit-Bold.woff\",\"weight\":\"700\",\"style\":\"normal\"}],\"variable\":\"--font-ambit\",\"display\":\"swap\",\"adjustFontFallback\":false}],\"variableName\":\"ambit\"}");
;
import(/* webpackMode: "eager" */ "/app/styles/cookieTractor.css");
;
import(/* webpackMode: "eager" */ "/app/styles/globals.css");
